import { NativeModules } from 'react-native';

const { RNZoomVideoSdkShareStatisticInfo } = NativeModules;

/**
 * Share statistic information.
 */
export type ZoomVideoSdkShareStatisticInfoType = {
  /**
   * Get the video's bit rate.
   */
  getBpf: () => Promise<boolean>;

  /**
   * Get the video's Frames Per Second (FPS).
   */
  getFps: () => Promise<boolean>;

  /**
   * Get the video's frame height.
   */
  getHeight: () => Promise<boolean>;

  /**
   * Get the video's frame width.
   */
  getWidth: () => Promise<boolean>;
};

export class ZoomVideoSdkShareStatisticInfo
  implements ZoomVideoSdkShareStatisticInfoType
{
  userId: string;

  constructor(userId: string) {
    this.userId = userId;
  }

  async getBpf() {
    return await RNZoomVideoSdkShareStatisticInfo.getBpf(this.userId);
  }

  async getFps() {
    return await RNZoomVideoSdkShareStatisticInfo.getFps(this.userId);
  }

  async getHeight() {
    return await RNZoomVideoSdkShareStatisticInfo.getHeight(this.userId);
  }

  async getWidth() {
    return await RNZoomVideoSdkShareStatisticInfo.getWidth(this.userId);
  }
}
